import { render } from "./SingleCalculation.vue?vue&type=template&id=5ea0bcba"
import script from "./SingleCalculation.vue?vue&type=script&lang=ts"
export * from "./SingleCalculation.vue?vue&type=script&lang=ts"
script.render = render

export default script